export default __webpack_public_path__ + "static/media/icon-transaksi-ac.e787c46f.png";